import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "user"
const UserIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 15C22.5 15 22.5 22.5 22.5 22.5H1.5S1.5 15 12 15M12 16.5C7.157 16.5 5.029 18.2 4.042 19.61 3.707 20.088 3.478 20.569 3.323 21H20.677C20.522 20.569 20.293 20.088 19.959 19.61 18.97 18.2 16.843 16.5 12 16.5M12 1.5C15.314 1.5 18 4.186 18 7.5S15.314 13.5 12 13.5 6 10.814 6 7.5 8.686 1.5 12 1.5M12 3C9.515 3 7.5 5.015 7.5 7.5S9.515 12 12 12 16.5 9.985 16.5 7.5 14.485 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UserIcon
